export type Overview = Views | string;

export enum Views {
    ALL_OBJECTS_OVERVIEW = 'ALL_OBJECTS_OVERVIEW',
    PUBLISHED_OVERVIEW = 'PUBLISHED_OVERVIEW',
    CONCEPTS_OVERVIEW = 'CONCEPTS_OVERVIEW',
    ARCHIVED_OVERVIEW = 'ARCHIVED_OVERVIEW',
    SIMILARITY_SEARCH = 'SIMILARITY_SEARCH',
    INTELLECTUAL_OVERVIEW = 'INTELLECTUAL_OVERVIEW',
    REPRESENTATIONS_OVERVIEW = 'REPRESENTATIONS_OVERVIEW',
    DOWNLOADS_OVERVIEW = 'DOWNLOADS_OVERVIEW',
    NOTIFICATIONS_OVERVIEW = 'NOTIFICATIONS_OVERVIEW',
    RECYCLE_BIN_OVERVIEW = 'RECYCLE_BIN_OVERVIEW',
    SAVED_QUERIES_OVERVIEW = 'SAVED_QUERIES_OVERVIEW',
    SELECTION_OVERVIEW = 'SELECTION_OVERVIEW',
    TASKS_OVERVIEW = 'TASKS_OVERVIEW',
    UPLOAD_OVERVIEW = 'UPLOAD_OVERVIEW',
    PORTAL_ALL_OVERVIEW = 'PORTAL_ALL_OVERVIEW',
    PORTAL_COLLECTION_OVERVIEW = 'PORTAL_COLLECTION_OVERVIEW',
    MGMT_USERS_OVERVIEW = 'MGMT_USERS_OVERVIEW',
    MGMT_ZONES_OVERVIEW = 'MGMT_ZONES_OVERVIEW',
    MGMT_GROUPS_OVERVIEW = 'MGMT_GROUPS_OVERVIEW',
    MGMT_BATCHES_OVERVIEW = 'MGMT_BATCHES_OVERVIEW',
    MGMT_ROLES_OVERVIEW = 'MGMT_ROLES_OVERVIEW',
    MGMT_FIELD_DEFINITIONS_OVERVIEW = 'MGMT_FIELD_DEFINITIONS_OVERVIEW',
    MGMT_EXPORT_LOCATIONS_OVERVIEW = 'MGMT_EXPORT_LOCATIONS_OVERVIEW',
    MGMT_PROFILES_OVERVIEW = 'MGMT_PROFILES_OVERVIEW',
    MGMT_CLASSIFICATIONS_OVERVIEW = 'MGMT_CLASSIFICATIONS_OVERVIEW',
    MGMT_FIELD_DEFINITIONS_DETAIL = 'MGMT_FIELD_DEFINITIONS_DETAIL'
}

export interface ViewOptions {
    view: Overview;
    filtersPanelOpen?: boolean;
    recordTreePanelOpen?: boolean;
}
